<template lang="pug">
  .password-validator
    | Password must:
    br
    span(:class="{'valid': length, 'invalid': !length}") {{ char(length) }}
    |  Be between 8-20 characters
    br
    span(:class="{'valid': userName, 'invalid': !userName}") {{ char(userName) }}
    |  Must not contain user name
    br
    span(:class="{'valid': firstLastName, 'invalid': !firstLastName}") {{ char(firstLastName) }}
    |  Must not contain first or last name
    br
    span(:class="{'valid': lowercase, 'invalid': !lowercase}") {{ char(lowercase) }}
    |  Contain at least one lower case letter
    br
    span(:class="{'valid': uppercase, 'invalid': !uppercase}") {{ char(uppercase) }}
    |  Contain at least one upper case letter
    br
    span(:class="{'valid': numeral, 'invalid': !numeral}") {{ char(numeral) }}
    |  Contain at least one numeral
    br
    span(:class="{'valid': special, 'invalid': !special}") {{ char(special) }}
    |  Contain at least one special character (except for + and =)
    br
    span(:class="{'valid': repeated, 'invalid': !repeated}") {{ char(repeated) }}
    |  Must not contain a character that is repeated consecutively more than twice
    br
    span(:class="{'valid': consecutiveNumbers, 'invalid': !consecutiveNumbers}") {{ char(consecutiveNumbers) }}
    |  Must not contain nine consecutive numbers
    br
    span(:class="{'valid': blankSpace, 'invalid': !blankSpace}") {{ char(blankSpace) }}
    |  Must not contain a space or blank
</template>

<script>
export default {
  name: 'PasswordValidator',
  props: {
    length: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: Boolean,
      default: false,
    },
    firstLastName: {
      type: Boolean,
      default: false,
    },
    lowercase: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    numeral: {
      type: Boolean,
      default: false,
    },
    special: {
      type: Boolean,
      default: false,
    },
    repeated: {
      type: Boolean,
      default: false,
    },
    consecutiveNumbers: {
      type: Boolean,
      default: false,
    },
    blankSpace: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    char: function(valid) {
      return valid ? '✔' : '•'
    },
  },
}
</script>

<style lang="scss">
@import '../assets/styles/bodies';
.password-validator {
  @extend .body-1;
}

.valid {
  display: inline-block;
  width: 2rem;
  text-align: center;
  color: green;
  font-size: 1.5rem;
  vertical-align: middle;
}

.invalid {
  display: inline-block;
  width: 2rem;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  vertical-align: middle;
}
</style>
